import React from "react";
import { Label } from "reactstrap";
import { IMultiSelectDropdown } from "../../../interfaces/Index";
import { Multiselect } from "multiselect-react-dropdown";
import "./MultiSelectDropDown.scss";

const MultiSelectDropDown: React.FunctionComponent<IMultiSelectDropdown> = (
  props: IMultiSelectDropdown
) => {
  return (
    <div className="form-group">
      <Label className="block text-uppercase label">{props.label}</Label>
      <Multiselect
        options={props.options}
        displayValue={props.displayValue}
        selectedValues={props.selectedValues}
        showCheckbox={props.showCheckbox}
        placeholder={props.placeholder}
        groupBy={props.groupBy}
        onSelect={props.onChange}
        disable={props.isDisable}
        hidePlaceholder={props.hidePlaceholder}
        onRemove={props.onRemove}
        className={props.className}
      />
    </div>
  );
};

export default MultiSelectDropDown;
